<template>
	<div class="journeys-skew-banner">
		<div class="container">
			<div class="row">
				<div class="col journeys-skew-banner__content text-center">
					<h1 class="h2">{{ microcopy?.heading }}</h1>
					<p>{{ microcopy?.summary }}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="container pull-up">
		<form class="w-100" @submit.prevent>
			<div class="rounded-container">
				<div class="row">
					<div class="col d-flex flex-column flex-md-row rounded-container__btn-col">
						<RadioInputComponent
							v-for="label in labelText"
							:key="label"
							:options="label"
							:selected-option="selected"
							@selected="(payload) => {
								handleSelection(payload)
							}"
						/>
					</div>
				</div>
			</div>
			<div class="row btm-btn-group m-auto mb-5">
                <div class="col text-center d-flex flex-column align-items-center">
					<GenericButton
						:label-text="progressionText"
						:button-disabled="!selected.selected"
						@button-click="handleClick"
					/>
					<BackButton
						@back-click="handleBackButton"
						:back-text="microcopy?.backButtonLabel"
						style="margin-top: 32px;"
					/>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import RadioInputComponent from '@/shared/components/RadioInputComponent.vue';
import GenericButton from '@/shared/components/GenericButton.vue';
import BackButton from '@/shared/components/BackButton.vue';
import router from '../router/index.js';

import { mapStores, mapActions, mapState } from 'pinia';
import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

export default {
	components: {
		RadioInputComponent,
		GenericButton,
		BackButton,
	},
	data() {
		return {
			selected: {
				selected: false
			},
			labelText: {
				yes: {
					text: '',
				},
				no: {
					text: '',
				},
			},
			progressionText: '',
			microcopy: '',
			backButtonText: ''
		};
	},
	computed: {
		...mapStores(useAppointmentReferralStore),
		...mapState(useAppointmentReferralStore, ['selectedKnownFC']),
		nextPage() {
			return this.selected.text === this.labelText.yes.text ? 'fc-selection' : 'profession';
		},
	},
	methods: {
		...mapActions(useAppointmentReferralStore, ['postKnownFC', 'postSelectedKnownFC']),
		handleClick() {
			this.postKnownFC(this.selected?.text?.includes(this.labelText.yes.text));
			router.push(this.nextPage);
		},
		handleBackButton() {
			router.back();
		},
		handleSelection(payload) {
			this.selected = payload;
			this.postSelectedKnownFC(this.selected);
		},
		assignMicrocopyText() {
			this.labelText.yes.text = this.microcopy?.yesOptionLabel;
			this.labelText.no.text = this.microcopy?.noOptionLabel;
			this.progressionText = this.microcopy?.nextButtonLabel;
			this.backButtonText = this.microcopy?.backButtonLabel;
			document.title = this.microcopy?.metaTitle;
		}
	},
	mounted() {
		const storedSelection = this.selectedKnownFC;
		if (storedSelection) {
			this.selected = storedSelection;
		}
		this.microcopy = window.bookAnAppointmentReferralMicrocopy?.knowYourFc;
		this.assignMicrocopyText();
		document.title = this.microcopy?.metaTitle
	},
};
</script>
